import React, { useEffect, useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import SbEditable from 'storyblok-react'

import Carousel from '../Carousel'
import TextRenderer from '../TextRenderer'

import styles from './styles.module.scss'

const TeamCarousel = (props) => {
    
    const params = {
        slidesPerView: typeof window != 'undefined' && window.innerWidth > 900 ? 4 : 2,
        loop: true,
        speed: 750,
        preloadImages: false,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        }
    }

    const { teamMembers } = useStaticQuery(graphql`
        query {
            teamMembers: allStoryblokEntry(filter: {field_component: {eq: "member"}}) {
                nodes {
                    uuid
                    slug
                    content
                }            
            }
        }
    `)

    return (
        <SbEditable content={props.blok}>
            <section className={styles['team-carousel']}>
                <div className='container'>
                    <TextRenderer className={styles['team-carousel__heading']} text={props.blok.heading} />
                </div>
                {props.blok.members.length > 0 ? (
                    <Carousel params={params}>
                        {props.blok.members.map((item, i) => {

                            const memberData = teamMembers.nodes.find(memberContent => {
                                return memberContent.uuid == item
                            })

                            if (!memberData) return null
                            
                            const memberBlok = JSON.parse(memberData.content)

                            return (
                                <div key={i} className={styles['team-member']} style={{ backgroundColor: memberBlok.background_color }}>
                                    <div className={styles['team-member__inner']}>
                                        {memberBlok.image.filename ? (
                                            <img className={styles['team-member__full-image']} src={memberBlok.image.filename} alt={memberBlok.image.alt} />
                                        ) : (
                                            <p>No image for: {memberBlok.name}</p>
                                        )}
                                    </div>
                                </div>
                            )
                        })}
                    </Carousel>
                ) : (
                    <p className='body' style={{ textAlign: 'center' }}>Team Carousel: Search and select members</p>
                )}
            </section>
        </SbEditable>
    )
}

export default TeamCarousel